import { Loading, useOrgUser, useOrganizations } from '@cibo/profile'
import { FriendlyError, Tabs, useParamAsInteger } from '@cibo/ui'
import { Breadcrumbs, Link, Tab } from '@mui/material'
import { LayoutSection } from 'components/ImpactLayout'
import { ADMIN_ROUTES } from 'navigation/types'
import { useTranslation } from 'react-i18next'
import { Outlet, Link as RRLink, generatePath, useLocation, useParams } from 'react-router-dom'
import { FDRRollups } from '../FDRRollups'

export const OrganizationDetail = () => {
  const { t } = useTranslation('impact/pages/OrganizationDetail')
  const { organizationId: orgId = '', programId } = useParams()
  const userId = useParamAsInteger('userId')
  const { pathname } = useLocation()
  const { data: orgs, isFetching } = useOrganizations()
  const { data: orgUser, isFetching: orgUserFetching } = useOrgUser(userId)

  const paths = pathname.split('/')
  const currentTab = paths[4]

  if (isFetching || orgUserFetching) {
    return <Loading />
  }

  const org = orgs?.items.find(org => org.orgInfo.orgId === orgId)

  if (!org) {
    return <FriendlyError message={t('orgNotFound')} />
  }

  return (
    <LayoutSection>
      <Breadcrumbs>
        <Link component={RRLink} to={'../'} underline="hover" color="inherit">
          {t('allOrgs')}
        </Link>
        <Link
          component={RRLink}
          underline="hover"
          color="text.primary"
          to={generatePath(ADMIN_ROUTES.ORGANIZATION_DETAIL, { organizationId: orgId })}
          aria-current="page"
        >
          {org.orgInfo.orgName}
        </Link>
        {currentTab === 'users' && userId ? (
          <Link>{orgUser?.displayNameFull}</Link>
        ) : currentTab === 'programs' && programId ? (
          <Link>{programId}</Link>
        ) : null}
      </Breadcrumbs>

      <FDRRollups orgId={orgId} />

      {!programId && !userId && (
        <Tabs value={currentTab || 'users'} variant="scrollable" scrollButtons="auto">
          <Tab
            component={RRLink}
            to={generatePath(ADMIN_ROUTES.ORGANIZATION_DETAIL_USERS, { organizationId: orgId })}
            label={t('users')}
            data-testid="org-users"
            value="users"
          />
          <Tab
            component={RRLink}
            to={generatePath(ADMIN_ROUTES.ORGANIZATION_DETAIL_PROGRAMS, { organizationId: orgId })}
            label={t('programs')}
            data-testid="org-programs"
            value="programs"
          />
        </Tabs>
      )}
      <Outlet />
    </LayoutSection>
  )
}
